import React from "react";

import { cn } from "../../../common/u1/cn";
import { PencilIcon, TrashIcon } from "../../../../assets/ui/icons";
import { SectionStatusPill } from "./SectionStatusPill";

/* The navy record card the Details and About sections share. */
export const DetailCard = ({
  status,
  rows = [],
  onEdit,
  onDelete,
  editLabel = "Edit Details",
  deleteLabel = "Delete",
  className = "",
}) => (
  <article
    className={cn(
      "relative flex flex-col overflow-hidden rounded-[14px] bg-[image:var(--doc-grad)]",
      className
    )}
  >
    {/* Corner-pinned rather than given a row of its own: on its own row it left a band of empty card above the first value, which the design does not have — the... */}
    {status && (
      <SectionStatusPill status={status} className="absolute right-3 top-3 z-[1]" />
    )}

    <dl className="m-0 flex flex-1 flex-col gap-3.5 p-4 sm:p-5">
      {rows.map((row, index) => {
        const Icon = row.icon;
        return (
          <div key={row.key} className="flex items-start gap-3">
            <span
              aria-hidden="true"
              className={cn(
                "mt-[2px] flex h-7 w-7 shrink-0 items-center justify-center rounded-lg",
                "border border-[var(--plan-pill-line)] bg-[var(--plan-pill-bg)]",
                "text-[var(--plan-pill-ink)]"
              )}
            >
              {Icon ? <Icon size={14} /> : null}
            </span>

            <div
              className={cn(
                "min-w-0 flex-1",
                /* Only the first row can collide with the pinned pill. */
                index === 0 && status && "pr-24"
              )}
            >
              <dt className="text-[10px] font-bold uppercase tracking-[0.12em] text-[var(--plan-micro)] font-sans">
                {row.label}
              </dt>
              {/* A value that has not been filled in would otherwise render an
                  empty line under its label. */}
              <dd className="m-0 mt-0.5 break-words text-[13px] font-semibold leading-[1.45] text-white font-sans">
                {row.value || row.value === 0 ? row.value : "—"}
              </dd>
            </div>
          </div>
        );
      })}
    </dl>

    {(onEdit || onDelete) && (
      /* A grid, not flex-1: two columns are exactly equal whatever the labels
         say, which is what "half and half" has to mean here. flex-1 sized to
         content in practice and left both buttons hugging the left edge. */
      <div
        className={cn(
          "grid border-t border-[var(--plan-rule)]",
          onEdit && onDelete ? "grid-cols-[1fr_1px_1fr]" : "grid-cols-1"
        )}
      >
        {onEdit && (
          <button
            type="button"
            onClick={onEdit}
            className={cn(
              "flex w-full items-center justify-center gap-2 px-4 py-3",
              "text-[13px] font-semibold text-white font-sans",
              "transition-colors hover:bg-white/10 focus-visible:outline-none",
              "focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-[var(--plan-pill-ink)]"
            )}
          >
            <PencilIcon size={14} />
            {editLabel}
          </button>
        )}

        {onEdit && onDelete && (
          <span aria-hidden="true" className="bg-[var(--plan-rule)]" />
        )}

        {onDelete && (
          <button
            type="button"
            onClick={onDelete}
            className={cn(
              "flex w-full items-center justify-center gap-2 px-4 py-3",
              "text-[13px] font-semibold text-white font-sans",
              "transition-colors hover:bg-white/10 focus-visible:outline-none",
              "focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-[var(--plan-pill-ink)]"
            )}
          >
            <TrashIcon size={14} />
            {deleteLabel}
          </button>
        )}
      </div>
    )}
  </article>
);

export default DetailCard;
